import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import OtpInput from 'react-otp-input';

const OtpVerifyCode = (props) => {

    useEffect(() => {
      if ('OTPCredential' in window) {
        async function fetchOtp() {
          try {
            const otp = await navigator.credentials.get({
              otp: { transport: ['sms'] },
            });
            if (otp?.code) {
              props.onChange(otp.code);
            }
          } catch (err) {
            console.error('Error fetching OTP:', err);
          }
        }
        fetchOtp();
      }
    }, []);

    return(
      <div className='otp-verify-code-wrapper'>
        <div className='otp-verify-code'>
          <OtpInput
              shouldAutoFocus={true}
              value={props.verifyCode}
              onChange={props.onChange}
              numInputs={props.numberOfInputs}
              isInputNum={true}
              separator={<span className='inputSeparator'></span>}
              inputStyle='input-design'
              containerStyle='mainDivInside'
              renderInput={(inputProps, index) => (
                <input {...inputProps} key={index} autoComplete="one-time-code" />
              )}
          />
        </div>
        <div className='error-msg'>{props.error}</div>
      </div>
    )
}

export default OtpVerifyCode;

